export default __webpack_public_path__ + "static/media/ZETH.5018bad9.svg";